var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 598.6 279.6",
    style: {
      enableBackground: "new 0 0 598.6 279.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF4500;}\n\t.st1{fill:#222222;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{display:none;}\n\t.st4{display:inline;fill:none;stroke:#D8D8D8;stroke-width:0.4925;stroke-miterlimit:10;}\n\t.st5{display:inline;fill:none;stroke:#D8D8D8;stroke-width:0.5589;stroke-miterlimit:10;}\n\t.st6{display:inline;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 495.4,
    cy: 113.7,
    r: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344,158.9c5.2,0,8.2-3.9,8-7.7c-0.1-2-0.3-3.3-0.5-4.3c-3.2-13.8-14.4-24-27.7-24 c-15.8,0-28.6,14.3-28.6,31.9c0,17.6,12.8,31.9,28.6,31.9c9.9,0,17-3.6,22.1-9.3c2.5-2.8,2-7.1-1-9.2c-2.5-1.7-5.6-1.1-7.9,0.8 c-2.2,1.9-6.4,5.7-13.2,5.7c-8,0-14.8-6.9-16.3-16H344z M323.7,135c7.2,0,13.4,5.6,15.7,13.3H308 C310.3,140.5,316.5,135,323.7,135z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.8,129.2c0-3-2.2-5.4-5-5.9c-8.7-1.3-16.9,1.9-21.6,7.8v-0.8c0-3.7-3-6-6-6c-3.3,0-6,2.7-6,6v49 c0,3.2,2.4,6,5.6,6.2c3.5,0.2,6.4-2.5,6.4-6v-25.3c0-11.2,8.4-20.4,20-19.1c0.4,0,0.8,0,1.2,0 C293.4,134.9,295.8,132.3,295.8,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.4,135.6c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,0.2,0,42,0,43.9c0,3.3,2.7,6,6,6s6-2.7,6-6 C501.4,177.7,501.4,135.9,501.4,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.2,102.4c0-3.3-2.7-6-6-6h0c-3.3,0-6,2.7-6,6l0,26.7c-4.1-4.1-9.2-6.1-15.3-6.1 c-15.8,0-28.6,14.3-28.6,31.9c0,17.6,12.8,31.9,28.6,31.9c6.1,0,11.3-2.1,15.4-6.2c0.5,2.8,3,4.9,5.9,4.9c3.3,0,6-2.7,6-6 C412.2,179.5,412.2,102.4,412.2,102.4z M385,174.9c-9.2,0-16.6-8.9-16.6-20c0-11,7.4-20,16.6-20c9.2,0,16.6,8.9,16.6,20 C401.6,166,394.1,174.9,385,174.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M474.8,102.4c0-3.3-2.7-6-6-6h0c-3.3,0-6,2.7-6,6l0,26.7c-4.1-4.1-9.2-6.1-15.3-6.1 c-15.8,0-28.6,14.3-28.6,31.9c0,17.6,12.8,31.9,28.6,31.9c6.1,0,11.3-2.1,15.4-6.2c0.5,2.8,3,4.9,5.9,4.9c3.3,0,6-2.7,6-6 C474.8,179.5,474.8,102.4,474.8,102.4z M447.5,174.9c-9.2,0-16.6-8.9-16.6-20c0-11,7.4-20,16.6-20c9.2,0,16.6,8.9,16.6,20 C464.1,166,456.7,174.9,447.5,174.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M531.8,179.6V135h5.3c2.8,0,5.3-2.1,5.5-5c0.2-3.1-2.3-5.7-5.3-5.7h-5.5v-8.4c0-3.2-2.4-6-5.6-6.2 c-3.5-0.2-6.4,2.5-6.4,6v8.7h-5c-2.8,0-5.3,2.1-5.5,5c-0.2,3.1,2.3,5.7,5.3,5.7h5.1v44.6c0,3.3,2.7,6,6,6l0,0 C529.2,185.5,531.8,182.9,531.8,179.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 139.8,
    cy: 139.8,
    r: 83.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M195.7,139.8c0-6.8-5.5-12.2-12.2-12.2c-3.3,0-6.3,1.3-8.5,3.4c-8.4-6-19.9-9.9-32.7-10.4l5.6-26.2l18.2,3.9 c0.2,4.6,4,8.3,8.7,8.3c4.8,0,8.7-3.9,8.7-8.7c0-4.8-3.9-8.7-8.7-8.7c-3.4,0-6.4,2-7.8,4.9l-20.3-4.3c-0.6-0.1-1.2,0-1.6,0.3 c-0.5,0.3-0.8,0.8-0.9,1.4l-6.2,29.2c-13,0.4-24.7,4.3-33.2,10.4c-2.2-2.1-5.2-3.4-8.5-3.4c-6.8,0-12.2,5.5-12.2,12.2 c0,5,3,9.2,7.2,11.1c-0.2,1.2-0.3,2.4-0.3,3.7c0,18.8,21.9,34.1,48.9,34.1s48.9-15.2,48.9-34.1c0-1.2-0.1-2.5-0.3-3.7 C192.7,149.1,195.7,144.8,195.7,139.8z M111.9,148.5c0-4.8,3.9-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7c0,4.8-3.9,8.7-8.7,8.7 C115.8,157.3,111.9,153.3,111.9,148.5z M160.6,171.6c-6,6-17.4,6.4-20.7,6.4c-3.4,0-14.8-0.5-20.7-6.4c-0.9-0.9-0.9-2.3,0-3.2 c0.9-0.9,2.3-0.9,3.2,0c3.8,3.8,11.8,5.1,17.5,5.1c5.7,0,13.8-1.3,17.5-5.1c0.9-0.9,2.3-0.9,3.2,0 C161.4,169.3,161.4,170.7,160.6,171.6z M159,157.3c-4.8,0-8.7-3.9-8.7-8.7c0-4.8,3.9-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7 C167.7,153.3,163.8,157.3,159,157.3z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Spacing_Guides",
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    width: 598.6,
    height: 55.9
  }), /*#__PURE__*/React.createElement("rect", {
    y: 223.6,
    className: "st4",
    width: 598.6,
    height: 55.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st5",
    width: 55.9,
    height: 279.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542.7,
    className: "st5",
    width: 55.9,
    height: 279.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "reddit_round",
    className: "st6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_2",
    className: "st6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.cd7bc6b679f96a7b2d787bc422e7a925.svg";
export { ForwardRef as ReactComponent };